import {useQueryParams} from '@aboutyou/router';

export const LIVE_AT_FILTER_KEY = 'minFirstLiveAt';

/**
 * Hook used to obtain the query param minFirstLiveAt, and validate the date format, if the format is incorrect the hook returns undefined.
 * Correct formats: 2021-6-27 | 2021-06-07 | 2021-6-7
 * Incorrect formats: 2021/6/27 | 2021-06 | 2021 | 06 | 2021-06/12
 *
 * @returns a date instance of the query param minFirstLiveAt
 */
export const useAppliedLiveAtFilter = () => {
  const queryParams = useQueryParams();

  const minFirstLiveAtParam = queryParams.get(LIVE_AT_FILTER_KEY);
  if (!minFirstLiveAtParam) return undefined;

  // https://regex101.com/r/iDByn0/2 - 2021-6-7 | 2021-06-07
  const dateRegExp =
    /^(\d{4}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12][0-9]|3[01]))$/;
  const minFirstLiveAtMatch = minFirstLiveAtParam.match(dateRegExp);
  if (minFirstLiveAtMatch === null) return undefined;

  const [stringYear, stringMonth, stringDay] = minFirstLiveAtParam.split('-');
  const year = Number(stringYear);
  // substracting 1, since month count start from 0
  const month = Number(stringMonth) - 1;
  const day = Number(stringDay);

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const date = new Date(Date.UTC(year, month, day));
  // 'en-US' as local so Date can be instantiated thanks to the format
  const toLocaleDateString = date.toLocaleString('en-US', {
    timeZone,
  });
  return new Date(Date.parse(toLocaleDateString));
};
